module.exports = __webpack_public_path__ + "img/POTENZA.691de3f1.png";